import { useAppSelector } from "@/store/app/hooks";
import {
  selectHasSparxTeaser,
  type SparxTeaserLoadStatus,
} from "@/features/sparxsEditor/store/slices/document/sparxTeaserSlice";

export const useHasSparxTeaser = (): boolean =>
  useAppSelector((state) =>
    selectHasSparxTeaser(state.editor.sparxTeaser, state.editor.activeSparx),
  );

export const useSparxTeaserData = () =>
  useAppSelector((state) => {
    const teaser = state.editor.sparxTeaser;
    if (teaser.fileName !== state.editor.activeSparx) {
      return null;
    }
    return teaser.data;
  });

export const useSparxTeaserStatus = (): SparxTeaserLoadStatus =>
  useAppSelector((state) => {
    const teaser = state.editor.sparxTeaser;
    if (teaser.fileName !== state.editor.activeSparx) {
      return "idle";
    }
    return teaser.status;
  });
